import {
  GetCounselingFollowUpsFollowUpStatusEnum,
  GetCounselingFollowUpsFollowUpTypeEnum,
  GetCounselingFollowUpsOrderByEnum,
  GetCounselingFollowUpsRequest,
  GetCounselingFollowUpsTypeEnum,
  MessengerCounseling,
  MessengerCounselingPatient,
  MessengerCounselingRequestTypeEnum,
  MessengerCounselingTypeEnum,
  MessengerFollowUp,
  MessengerFollowUpChainFollowUpJobStatusEnum,
  MessengerFollowUpFollowUpTypeEnum,
  MessengerFollowUpNotificationPattern,
  MessengerFollowUpNotificationPatternFollowUpTypeEnum,
  MessengerFollowUpNotificationPatternRegistrableSendMethodEnum,
  MessengerFollowUpNotificationPatternSendMethodEnum,
  MessengerFollowUpNotificationPatternUpdatableSendMethodEnum,
  MessengerFollowUpQuestionnaire,
  MessengerFollowUpQuestionnairePattern,
  MessengerFollowUpQuestionnairePatternFollowUpTypeEnum,
  MessengerFollowUps,
  MessengerFollowUpStatusEnum,
  MessengerFollowUpUpdatable,
  MessengerFollowUpUpdatableStatusEnum,
  MessengerQuestionnaire,
  MessengerQuestionnaireAnswerPatternEnum,
  MessengerQuestionnaireCategoryEnum,
} from "@mgdx/api/lib/pharmacy/messenger";

import { PharmacyCounseling } from "./PharmacyCounseling";

export type CounselingFollowUp = MessengerFollowUp;
export type FollowUpCounseling = MessengerCounseling;
export type CounselingPatient = MessengerCounselingPatient;

export const defaultSearchCounselingFollowUpPer = 10;

export type CounselingWithFollowUp = {
  counseling: PharmacyCounseling;
  followUp: CounselingFollowUp;
};

export const CounselingFollowUpStatusEnum = MessengerFollowUpStatusEnum;

export const CounselingFollowUpTypeEnum = MessengerFollowUpFollowUpTypeEnum;

export const CounselingFollowUpChainJobStatusEnum = MessengerFollowUpChainFollowUpJobStatusEnum;

export const CounselingRequestTypeEnum = MessengerCounselingRequestTypeEnum;

export const CounselingTypeEnum = MessengerCounselingTypeEnum;

export const FollowUpNotificationPatternSendMethodEnum = MessengerFollowUpNotificationPatternSendMethodEnum;

export const FollowUpNotificationPatternUpdatableSendMethodEnum =
  MessengerFollowUpNotificationPatternUpdatableSendMethodEnum;

export const FollowUpNotificationPatternRegistrableSendMethodEnum =
  MessengerFollowUpNotificationPatternRegistrableSendMethodEnum;

export const FollowUpUpdatableStatusEnum = MessengerFollowUpUpdatableStatusEnum;

export type CounselingFollowUps = MessengerFollowUps;

export type FollowUpNotificationPattern = MessengerFollowUpNotificationPattern;

export type FollowUpQuestionnaire = MessengerFollowUpQuestionnaire;

export type FollowUpQuestionnairePattern = MessengerFollowUpQuestionnairePattern;

export type FollowUpUpdatable = MessengerFollowUpUpdatable;

export type Questionnaire = MessengerQuestionnaire;

export { MessengerFollowUpFollowUpTypeEnum };

export { MessengerFollowUpStatusEnum };

export { MessengerQuestionnaireAnswerPatternEnum };

export { MessengerQuestionnaireCategoryEnum };

export const FollowUpNotificationPatternFollowUpTypeEnum = MessengerFollowUpNotificationPatternFollowUpTypeEnum;

export const FollowUpQuestionnairePatternFollowUpTypeEnum = MessengerFollowUpQuestionnairePatternFollowUpTypeEnum;

export { GetCounselingFollowUpsFollowUpStatusEnum };

export { GetCounselingFollowUpsFollowUpTypeEnum };

export { GetCounselingFollowUpsOrderByEnum };

export { GetCounselingFollowUpsTypeEnum };

export type { GetCounselingFollowUpsRequest };
